import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import React, {Component} from 'react';
import axios from "axios";
import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import NumberFormat from 'react-number-format';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneInput from 'react-phone-number-input';
import CheckIcon from "@mui/icons-material/Check";
import "./style.css";
import {useNavigate} from "react-router-dom";

export default function NewInquiry(){
    const [kualitasInq, setKualitasInq] = useState(7);
    const [names,setNames] = useState(["Instagram/Facebook Ads", "Google Ads (LiveChat)", "Google Ads (WhatsApp)", "Partner", "Kenalan", "Ga Tau"]);
    const [produk,setProduk] = useState(["Virtual Office", "Private Office", "Meeting Room Kecil", "Meeting Room Besar (Event Room)", "Pendirian PT", "Pendirian CV", "Izin Khusus", "PKP", "Pajak", "Akutansi", "Website", "Merek"]);
    const [lokasi,setLokasi] = useState(["Jakarta Selatan", "Jakarta Barat", "Jakarta Pusat", "Jakarta Utara", "Jakarta Timur", "Tangerang", "Bekasi", "Bali", "Surabaya", "Depok", "Kalimantan"]);
    const [sales, setSales]= useState(["Adnan", "Diva", "Felly", "Reinner"])
    const [selectedLokasi, setSelectedLokasi] = useState();
    const [selectedSales, setSelectedSales] = useState([]);
    const [selectedRooms, setSelectedRooms] = useState([]);
    const [inqDate,setInqDate]= useState(new Date())
    const [namaKlien,setNamaKlien] = useState();
    const [notes, setNotes]= useState();
    const [selectedProduk, setSelectedProduk] = useState();
    const [hariIni,setHariIni] = useState(new Date())
    const [error, setError] = useState()
    const navigate = useNavigate();
    const history = useNavigate();

    const saveInquiry = () => {
        if(kualitasInq && phoneNumber && selectedRooms){
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveInq`, {
                phoneNumber, kualitasInq,selectedLokasi,selectedSales,selectedIklan:selectedRooms,inqDate,namaKlien,notes,selectedProduk,hariIni
            }).then(response => {
                console.log(response.data );
                history("/proformainvoice",{state:{stuff:"new",
                Inquiry: {
                    Phone: phoneNumber,
                    _id: response.data._id,
                    Sales: selectedSales,
                  },
                }})
            }).catch(error => {
                console.log(error.message)
                console.log("test")
                console.error(error);
                console.log("r")
                console.error(error.r)
                if (error.response && error.response.data && error.response.data.message) {
                    setError(error.response.data.message); // this will show "Nomor Telepon sudah ada"
                } else {
                    setError(error.message);
                }
            });


        }else{
            setError("Ada data yang belum kamu isi")
        }
    }
    
    const [phoneNumber, setPhoneNumber] = useState('');
    const handleBDateChange = (date) => {
        setInqDate(date);
    }
    return <Grid container sx={{p:2}}>
    

    <Grid item>

        <Grid>
            <Grid container>
                <Grid sm={2}>
                    Nomor Telepon*:
                </Grid>
                <Grid sm={7}>
                    <PhoneInput
                        international
                        defaultCountry="ID"
                        value={phoneNumber}
                        placeholder="Nomor Telepon"
                        onChange={setPhoneNumber}
                    />
                </Grid>
            </Grid>         
            <Grid container sx={{mt:5}}>
                <Grid sm={2}>
                    Dari*:
                </Grid>
                <Grid sm={10}>
                    <Autocomplete
                                  sx={{ width: 360 }}
                                  multiple
                                  options={names}
                                  freeSolo
                                  getOptionLabel={(option) => option}
                                  disableCloseOnSelect
                                  value={selectedRooms}
                                  onChange={(event, newValue) => {
                                    setSelectedRooms(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      label="Pilih Iklan"
                                      placeholder="Pilih Iklan"
                                    />
                                  )}
                                  renderOption={(props, option, { selected }) => (
                                    <MenuItem
                                      {...props}
                                      key={option}
                                      value={option}
                                      sx={{ justifyContent: "space-between" }}
                                    >
                                      {option}
                                      {selected ? <CheckIcon color="info" /> : null}
                                    </MenuItem>
                                  )}
                                />
                </Grid>
            </Grid>
            <Grid container sx={{mt:5}}>
                <Grid sm={2}>
                    Sales*:
                </Grid>
                <Grid sm={7}>
                    <Autocomplete
                                    sx={{ width: 360 }}
                                    options={sales}
                                    freeSolo
                                    getOptionLabel={(option) => option}
                                    disableCloseOnSelect
                                    value={selectedSales}
                                    onChange={(event, newValue) => {
                                        setSelectedSales(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Pilih Sales"
                                        placeholder="Pilih Sales"
                                        />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <MenuItem
                                        {...props}
                                        key={option}
                                        value={option}
                                        sx={{ justifyContent: "space-between" }}
                                        >
                                        {option}
                                        {selected ? <CheckIcon color="info" /> : null}
                                        </MenuItem>
                                    )}
                                    />                
                    </Grid>
            </Grid>
            {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}
            <Button variant="contained" color="success" onClick={saveInquiry}>Save Inquiry</Button>
        </Grid>
        
    </Grid>
    
</Grid>
}